package com.example.mystybag.e5AiSearch.helpers

import kotlin.math.sqrt

fun normalizeText(s: String): String =
    s.trim().replace(Regex("\\s+"), " ")

fun meanPool(
    hidden: Array<FloatArray>,      // [maxLen][dim]
    attentionMask: LongArray,       // [maxLen]
    dim: Int
): FloatArray {
    val pooled = FloatArray(dim)
    var count = 0f
    for (i in attentionMask.indices) {
        if (attentionMask[i] == 0L) continue
        val tokenVec = hidden[i]
        for (d in 0 until dim) pooled[d] += tokenVec[d]
        count += 1f
    }
    if (count > 0f) for (d in 0 until dim) pooled[d] /= count
    return pooled
}

fun l2Normalize(v: FloatArray): FloatArray {
    var sum = 0f
    for (x in v) sum += x * x
    val norm = sqrt(sum)
    if (norm == 0f) return v
    for (i in v.indices) v[i] /= norm
    return v
}

data class Tokens(
    val inputIds: LongArray,
    val attentionMask: LongArray,
    val tokenTypeIds: LongArray
)